import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M20 36c8.837 0 16-7.163 16-16S28.837 4 20 4 4 11.163 4 20s7.163 16 16 16zm-2.586-21.414a2 2 0 1 0-2.828 2.828L17.172 20l-2.586 2.586a2 2 0 1 0 2.828 2.828L20 22.828l2.586 2.586a2 2 0 1 0 2.828-2.828L22.828 20l2.586-2.586a2 2 0 1 0-2.828-2.828L20 17.172l-2.586-2.586z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }